import classNames from 'classnames'
import React, { useEffect, useMemo } from 'react'
import type {
  FC,
  HTMLAttributes,
  TdHTMLAttributes,
  ThHTMLAttributes
} from 'react'

import { useCellTitle } from './use-cell-title'
import useHover from '../../hooks/use-hover'
import { callAll } from '../../utils/function'

export const TableBody: FC<HTMLAttributes<HTMLTableSectionElement>> = props => {
  const { children, ...rest } = props
  return <tbody {...rest}>{children}</tbody>
}

export const TableCaption: FC<HTMLAttributes<HTMLElement>> = props => {
  const { children, ...rest } = props
  return <caption {...rest}>{children}</caption>
}

export const TableCell: FC<
  TdHTMLAttributes<HTMLTableCellElement> & {
    title?: string
  }
> = props => {
  const { children, title, onMouseEnter: _onMouseEnter, ...rest } = props

  const onMouseEnter = useCellTitle(title)
  const handelOnMouseEnter = useMemo(
    () => callAll(_onMouseEnter, onMouseEnter),
    [_onMouseEnter, onMouseEnter]
  )
  // eslint-disable-next-line no-console
  // console.log('rendering tables.cell [TableCell]')
  return (
    <td onMouseEnter={handelOnMouseEnter} {...rest}>
      {children}
    </td>
  )
}

export const TableFoot: FC<HTMLAttributes<HTMLTableSectionElement>> = props => {
  const { children, ...rest } = props
  return <tfoot {...rest}>{children}</tfoot>
}

export const TableHeadCell: FC<
  ThHTMLAttributes<HTMLTableCellElement> & {
    title?: string
  }
> = props => {
  const { children, title, onMouseEnter: _onMouseEnter, ...rest } = props

  const onMouseEnter = useCellTitle(title)
  const handelOnMouseEnter = useMemo(
    () => callAll(_onMouseEnter, onMouseEnter),
    [_onMouseEnter, onMouseEnter]
  )
  return (
    <th onMouseEnter={handelOnMouseEnter} {...rest}>
      {children}
    </th>
  )
}

export const TableHead: FC<HTMLAttributes<HTMLTableSectionElement>> = props => {
  const { children, ...rest } = props
  return <thead {...rest}>{children}</thead>
}

export const TableRow: FC<
  HTMLAttributes<HTMLTableRowElement> & {
    onHover?: (
      isHovering?: boolean,
      rowRef?: React.RefObject<HTMLDivElement>
    ) => void
  }
> = props => {
  const { children, className, onHover, ...rest } = props
  const [isHovering, hoverRef] = useHover<HTMLTableRowElement>()
  // eslint-disable-next-line no-console
  // console.log('rendering tables.row')
  useEffect(() => {
    if (onHover) {
      onHover(isHovering, hoverRef)
    }
  }, [onHover, isHovering, hoverRef])
  return (
    <tr
      ref={hoverRef}
      className={classNames(className, { 'is-hover': isHovering })}
      {...rest}
    >
      {children}
    </tr>
  )
}
